<template>
  <div class="vehicles"
  :class="{'page': !isInPopup}">
    <div class="title_line flex justify-between">
      <div class="inline-block flex justify-between items-center"
        :class="{
        'w-full' : isInPopup,
        'w-1/3' : !isInPopup
      }"
      >
        <h1 class="text-left">Vehicles</h1>
        <span v-if="isInPopup" class="pointer" @click="closePopup()">
          x
        </span>
      </div>

      <div class="inline-block flex w-2/3 justify-end button_group" v-if="!isInPopup">
        <button class="text-white flex items-center button_text in_row_button full_green_button">
          <router-link to="/add-vehicle" class="flex items-center">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 4V19.9996" stroke="white" stroke-width="2" stroke-linecap="round"/>
              <path d="M20 12L4.00038 12" stroke="white" stroke-width="2" stroke-linecap="round"/>
            </svg>

            <span class="h-full">
              Add Vehicle
            </span>
          </router-link>
        </button>

        <button
            v-if="show_buttons"
            @click="openAssignModal('assign_vehicle_group_modal')"
            class="flex items-center in_row_button square_button square_green_button">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 19V5C1 3.34315 2.34315 2 4 2H7.39445C8.39751 2 9.3342 2.5013 9.8906 3.3359L10.1094 3.6641C10.6658 4.4987 11.6025 5 12.6056 5H21C22.1046 5 23 5.89543 23 7V19C23 20.1046 22.1046 21 21 21H3C1.89543 21 1 20.1046 1 19Z" stroke="#1FBC2F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8 13L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17 10" stroke="#1FBC2F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>

        <button
            v-if="show_buttons"
            @click="openAssignModal('remote_assign_modal')"
            class="flex items-center in_row_button square_button square_green_button">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 19V5C1 3.34315 2.34315 2 4 2H7.39445C8.39751 2 9.3342 2.5013 9.8906 3.3359L10.1094 3.6641C10.6658 4.4987 11.6025 5 12.6056 5H21C22.1046 5 23 5.89543 23 7V19C23 20.1046 22.1046 21 21 21H3C1.89543 21 1 20.1046 1 19Z" stroke="#1FBC2F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8 13H16" stroke="#1FBC2F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>

        <button
            @click="openDeleteModal"
            :disabled="!show_buttons"
            class="flex items-center in_row_button square_button square_red_button">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 4C8 2.89543 8.89543 2 10 2H14C15.1046 2 16 2.89543 16 4V6H8V4Z" stroke="#F2374D" stroke-width="2"/>
            <path d="M3 6H21" stroke="#F2374D" stroke-width="2" stroke-linecap="round"/>
            <path d="M6.33 20.1867L5 6H19L17.67 20.1867C17.5736 21.2144 16.711 22 15.6787 22H8.32127C7.28902 22 6.42635 21.2144 6.33 20.1867Z" stroke="#F2374D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10 18L9.5 10" stroke="#F2374D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M14 18L14.5 10" stroke="#F2374D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>

        <div class="relative inline-flex shrink-0 manage_menu_wrap">
          <button
              type="button"
              @click="show_manage = !show_manage"
              class="flex items-center last_in_row_button square_button square_green_button">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="3.5" r="2.5" fill="#1FBC2F"/>
              <circle cx="12" cy="12" r="2.5" fill="#1FBC2F"/>
              <circle cx="12" cy="20.5" r="2.5" fill="#1FBC2F"/>
            </svg>
          </button>

          <div
              id="manage_group_block"
              v-if="show_manage"
              class="manage_group">
            <button type="button" @click="openCsvUploadFromMenu" class="block manage_menu_item">
              Upload CSV
            </button>
            <a
              :href="vehiclesImportTemplatePath"
              :download="vehiclesImportTemplateFilename"
              title="Download vehicle import template"
              class="block manage_menu_item manage_menu_link"
              @click="closeManageMenu"
            >
              Template
            </a>
            <button type="button" @click="openCreateVehicleGroup" class="block manage_menu_item">
              Create vehicle group
            </button>
            <button type="button" @click="openManageGroupsModal" class="block manage_menu_item">
              Manage vehicle group
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="filters">
      <FiltersDop
          :min_filter="min_filter"
          :names="vehicle_names"
          :selected_name="selected_name"
          :items_count="vehicles_count"
          :rows_length="vehicles.length"
          :rows_count="rows_count"
          :useLocalState="isInPopup"
          @state-change="onPaginationChange"
      ></FiltersDop>
    </div>

    <div class="customers_table mt-4 px-4"
      :class="{'fl_table': !isInPopup}"
    >
      <div class="wrap" v-if="vehicles">
        <div class="header py-3 px-2 flex text-left justify-between">
          <div class="item flex items-center justify-center w-24px">
            <input
              type="checkbox"
              :checked="hasAnyRowSelected"
              :indeterminate.prop="hasAnyRowSelected && !allRowsSelected"
              @change="onToggleSelectAll"
            >
          </div>
          <div class="item flex items-center justify-between w-1/12 ">
            <span class="strong_text "
                  :class="{'span_cut': isInPopup}"
            >
              Vehicle name
            </span>
            <span class="sort"
                  @click="sortItems('name')"
                  :class="{
                    'hidden': !sort_names.name,
                    'rotate': ascending
                  }">
              <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.82406 6.80139C5.42671 7.37935 4.57332 7.37936 4.17597 6.80139L0.576992 1.56653C0.120833 0.903028 0.595854 8.78263e-08 1.40103 1.58217e-07L8.59897 -1.66193e-07C9.40415 -9.58021e-08 9.87917 0.903026 9.42302 1.56653L5.82406 6.80139Z" fill="black"/>
              </svg>
            </span>
          </div>
          <div class="item w-1/12"
            :class="{'span_cut': isInPopup}"
          >
            Group
          </div>
          <div class="item w-3/12"
            :class="{'span_cut': isInPopup}"
          >
            Type
          </div>
          <div class="item w-1/12"
            :class="{'span_cut': isInPopup}"
          >
            Reg. number
          </div>
          <div class="item w-1/12"
            :class="{'span_cut': isInPopup}"
          >
            Make
          </div>
          <div class="item w-1/12"
            :class="{'span_cut': isInPopup}"
          >
            Height
          </div>
          <div class="item w-1/12"
            :class="{'span_cut': isInPopup}"
          >
            Width
          </div>
          <div class="item w-1/12"
            :class="{'span_cut': isInPopup}"
          >
            Length
          </div>
          <div class="item w-1/12"
            :class="{'span_cut': isInPopup}"
          >
            Weight
          </div>
          <div class="item delete_column" v-if="!isInPopup"></div>
        </div>
        <div class="body py-2">
          <div
              v-for="(vehicle, index) in vehicles"
              :key="index" :class="checked_vehicle[index] ? 'checked_row' : ''"
              class="py-5 px-2 flex text-left justify-between">
            <div class="item flex items-center justify-center w-24px">
              <input
                  :id="'checked-input-' + index"
                  v-model="checked_vehicle[index]"
                  type='checkbox'>
            </div>
            <div class="item flex items-center justify-between w-1/12">
              <router-link :to="{path: 'vehicles/' + vehicle.id}" class="green_text span_cut">
                {{ vehicle.name }}
              </router-link>
            </div>
            <div class="item flex items-center justify-between w-1/12">
              <span class="span_cut color_black">
                {{ vehicle.vehicle_groups.length ? vehicle.vehicle_groups[0].name : ''}}
              </span>
            </div>
            <div class="item flex items-center justify-between w-3/12">
              <span class="span_cut color_black">
                {{ vehicle.vehicle_type ? parseTypeByKeys(vehicle.vehicle_type) : '-' }}
              </span>
            </div>
            <div class="item flex items-center justify-between w-1/12 uppercase">
              <span class="span_cut color_black">
                {{ vehicle.registration_number }}
              </span>
            </div>
            <div class="item flex items-center justify-between w-1/12 uppercase">
              <span class="span_cut color_black">
                {{ vehicle.vehicle_make }}
              </span>
            </div>
            <div class="item flex items-center justify-start w-1/12">
              {{ vehicle.height }}
              <span>
                m
              </span>
            </div>
            <div class="item flex items-center justify-start w-1/12">
              {{ vehicle.width }}
              <span>
                m
              </span>
            </div>
            <div class="item flex items-center justify-start w-1/12">
              {{ vehicle.length }}
              <span>
                m
              </span>
            </div>
            <div class="item flex items-center justify-start w-1/12">
              {{ vehicle.weight }}
              <span>
                t
              </span>
            </div>
            <div class="item flex items-center justify-center w-44px" v-if="!isInPopup">
              <button @click="deleteThisVehicle(index)" class="flex items-center justify-center">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 4C8 2.89543 8.89543 2 10 2H14C15.1046 2 16 2.89543 16 4V6H8V4Z" stroke="#F2374D" stroke-width="2"/>
                  <path d="M3 6H21" stroke="#F2374D" stroke-width="2" stroke-linecap="round"/>
                  <path d="M6.33 20.1867L5 6H19L17.67 20.1867C17.5736 21.2144 16.711 22 15.6787 22H8.32127C7.28902 22 6.42635 21.2144 6.33 20.1867Z" stroke="#F2374D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M10 18L9.5 10" stroke="#F2374D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M14 18L14.5 10" stroke="#F2374D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="selected_table pb-15 px-4" v-if="isInPopup">
      <div class="top flex justify-between items-center w-full">
        <h3 class="w-1/3">Selected Vehicles for the Route</h3>
        <div class="filters w-2/3">
          <FiltersDop
              :min_filter="min_filter"
              :names="vehicle_names"
              :selected_name="selected_name"
              :items_count="selectedVehicles.length"
              :rows_length="selectedVehicles.length"
              :rows_count="rows_count"
              :isInPopup="isInPopup"
              :hide_pagination="true"
          ></FiltersDop>
        </div>
      </div>
      <div class="selected_vehicles">
        <div class="header py-3 px-2 flex text-left justify-between">
          <div class="item flex items-center justify-between w-1/12 text-gray-700">
            Vehicle name
          </div>
          <div class="span_cut item w-1/12">
            Group
          </div>
          <div class="span_cut item w-3/12">
            Type
          </div>
          <div class="span_cut item w-1/12">
            Reg. number
          </div>
          <div class="span_cut item w-1/12">
            Make
          </div>
          <div class="span_cut item w-1/12">
            Height
          </div>
          <div class="span_cut item w-1/12">
            Width
          </div>
          <div class="span_cut item w-1/12">
            Length
          </div>
          <div class="span_cut item w-1/12">
            Weight
          </div>
          <div class="item delete_column" v-if="!isInPopup"></div>
        </div>

        <div class="body py-2">
          <div
              v-for="(vehicle, index) in selectedVehicles"
              :key="index" class="py-5 px-2 flex text-left justify-between">
            <div class="item flex items-center justify-between w-1/12">
              <span class="green_text span_cut">
                {{ vehicle.name }}
              </span>
            </div>
            <div class="item flex items-center justify-between w-1/12">
              <span class="span_cut color_black">
                {{ vehicle.vehicle_groups.length ? vehicle.vehicle_groups[0].name : '' }}
              </span>
            </div>
            <div class="item flex items-center justify-between w-3/12">
              <span class="span_cut color_black">
                {{ vehicle.vehicle_type ? vehicle.vehicle_type : '-' }}
              </span>
            </div>
            <div class="item flex items-center justify-between w-1/12">
              <span class="span_cut color_black">
                {{ vehicle.registration_number }}
              </span>
            </div>
            <div class="item flex items-center justify-between w-1/12 uppercase">
              <span class="span_cut color_black">
                {{ vehicle.vehicle_make }}
              </span>
            </div>
            <div class="item flex items-center justify-start w-1/12">
              {{ vehicle.height }}
              <span>
                m
              </span>
            </div>
            <div class="item flex items-center justify-start w-1/12">
              {{ vehicle.width }}
              <span>
                m
              </span>
            </div>
            <div class="item flex items-center justify-start w-1/12">
              {{ vehicle.length }}
              <span>
                m
              </span>
            </div>
            <div class="item flex items-center justify-start w-1/12">
              {{ vehicle.weight }}
              <span>
                t
              </span>
            </div>
            <div class="item flex items-center justify-center w-44px">
              <button @click="deleteSelectedVehicle(index)" class="flex items-center justify-center">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 4C8 2.89543 8.89543 2 10 2H14C15.1046 2 16 2.89543 16 4V6H8V4Z" stroke="#F2374D" stroke-width="2"/>
                  <path d="M3 6H21" stroke="#F2374D" stroke-width="2" stroke-linecap="round"/>
                  <path d="M6.33 20.1867L5 6H19L17.67 20.1867C17.5736 21.2144 16.711 22 15.6787 22H8.32127C7.28902 22 6.42635 21.2144 6.33 20.1867Z" stroke="#F2374D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M10 18L9.5 10" stroke="#F2374D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M14 18L14.5 10" stroke="#F2374D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <CSVUploadVehicles
      v-if="!isInPopup && upload_csv"
      @cancel="onCsvUploadDismiss"
      @import-complete="onVehiclesCsvImportComplete"
    />

    <div class="blocked" v-if="show_manage" @click="closeManageMenu"></div>
    <DeleteModal
      v-on:delete-select="deleteSelectVehicle"
      v-on:delete-close="closeDeleteModal"
      ref="delete_modal"
    />

    <CreateVehicleGroupModal
        v-on:close-create-vehicle-group-modal-success="checkedCloseCreateGroup(true)"
        v-on:close-create-vehicle-group-modal-error="checkedCloseCreateGroup(false)"
        ref="create_vehicle_group_modal"></CreateVehicleGroupModal>

    <AssignVehiclesToGroup
        :vehicle_groups="vehicle_groups"
        :assigned_ids="assigned_ids"
        v-on:assign-select-false="closeAssignModal(false)"
        v-on:assign-select-success="closeAssignModal(true)"
        ref="assign_vehicle_group_modal"></AssignVehiclesToGroup>

    <RemoveVehiclesFromAssignedGroups
        :assigned_ids="assigned_ids"
        v-on:remote-select-success="closeAssignModal(true, 'Removed vehicles from group!')"
        v-on:remote-select-false="closeAssignModal(false)"
        ref="remote_assign_modal"></RemoveVehiclesFromAssignedGroups>

    <MenageVehiclesGroup
        :userId="user ? user.id : 0"
        v-on:manage-close="reloadItems"
        ref="menage_vehicle_groups"></MenageVehiclesGroup>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";
import FiltersDop from '../../components/FiltersDop';
import DeleteModal from "@/components/DeleteModal";
import CreateVehicleGroupModal from '../../components/CreateVehicleGroupModal';
import AssignVehiclesToGroup from '../../components/AssignVehiclesToGroup';
import RemoveVehiclesFromAssignedGroups from '../../components/RemoveVehiclesFromAssignedGroups';
import MenageVehiclesGroup from '../../components/MenageVehiclesGroup';
import CSVUploadVehicles from '@/components/CSVUploadVehicles';
import {
  VEHICLES_IMPORT_TEMPLATE_FILENAME,
  VEHICLES_IMPORT_TEMPLATE_PATH,
} from '@/constants/vehiclesImport';

import {infoMessage} from "../../services/messages";
import {parseTypeByKeys} from "@/services/helpers";
import structuredClone from '@ungap/structured-clone';

export default {
  name: "Vehicles",
  props: {
    isInPopup: {
      type: Boolean,
      default: false
    },
    rows_count: {
      type: Number,
      default: 10
    },
    selected_vehicles_ids: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      vehiclesImportTemplatePath: VEHICLES_IMPORT_TEMPLATE_PATH,
      vehiclesImportTemplateFilename: VEHICLES_IMPORT_TEMPLATE_FILENAME,
      upload_csv: false,
      min_filter: true,
      sort_names: {
        name: true,
      },
      vehicle_names:[
        {
          name: 'Reg. number',
          id: 'registration_number'
        },
        {
          name: 'Vehicle name',
          id: 'name'
        },
        // {
        //   name: 'Vehicle group name',
        //   id: 'group_name'
        // }
      ],
      selected_name: {name: 'Reg. number', id: 'registration_number'},
      user: null,
      text_file: null,

      checked_vehicle: [],
      show_buttons: false,
      show_manage: false,
      delete_id: null,
      ascending: false,
      vehicles: [],
      selectedVehicles: [],
      vehicles_count: null,
      vehicle_groups: [],
      assigned_ids: [],
      popupSkip: 0,
      popupTake: this.rows_count,
      popupSearch: '',
      popupSort: 'registration_number',
    }
  },
  methods: {
    parseTypeByKeys,
    ...mapMutations([
      'setVehiclesDimensions',
      'setSelectedVehicles',
      'setAddVehicles'
    ]),
    closePopup() {
      this.setAddVehicles(false); //todo remove it after v2 routing full migration
      this.$emit('closePopup')
    },
    onPaginationChange({ skip, take, search, sortId }) {
      this.popupSkip = skip;
      this.popupTake = take;
      this.popupSearch = search;
      if (sortId != null) {
        this.popupSort = sortId;
      }
      this.getListVehicles();
    },
    closeManageMenu() {
      this.show_manage = false;
    },
    openManageGroupsModal() {
      this.closeManageMenu();
      this.$refs.menage_vehicle_groups.show = true;
    },
    onToggleSelectAll() {
      this.setRowSelection(!this.allRowsSelected);
    },
    setRowSelection(selected) {
      const list = this.vehicles || [];
      this.checked_vehicle = list.map(() => selected);
      if (this.isInPopup) {
        if (selected) {
          list.forEach((vehicle) => {
            if (!this.selectedVehicles.find((v) => v.id === vehicle.id)) {
              this.selectedVehicles.push(vehicle);
            }
          });
        } else {
          const pageIds = new Set(list.map((v) => v.id));
          this.selectedVehicles = this.selectedVehicles.filter(
            (v) => !pageIds.has(v.id),
          );
        }
        this.recalcVehiclesDimensions();
      } else {
        this.show_buttons = selected && list.length > 0;
      }
    },
    syncSelectedVehiclesFromCheckboxes() {
      (this.vehicles || []).forEach((vehicle, index) => {
        const checked = !!this.checked_vehicle[index];
        const existingIndex = this.selectedVehicles.findIndex(
          (v) => v.id === vehicle.id,
        );
        if (checked && existingIndex === -1) {
          this.selectedVehicles.push(vehicle);
        } else if (!checked && existingIndex !== -1) {
          this.selectedVehicles.splice(existingIndex, 1);
        }
      });
    },
    async updateAssignedIds() {
      this.assigned_ids = [];
      for (let key in this.checked_vehicle) {
        if (this.checked_vehicle[key]) {
          this.assigned_ids.push(this.vehicles[key].id);
        }
      }
    },
    async openAssignModal(name) {
      if (this.checked_vehicle.length) {
        await this.updateAssignedIds();
      }

      this.$refs[name].show = true;
    },
    async closeAssignModal(val, message = null) {
      this.assigned_ids = [];
      this.show_buttons = false;

      if (val) {
        infoMessage(
            message || `Assign vehicles to group!`,
            this.getTopBanner ? 'success open_top_banner' : 'success'
        );
      } else {
        infoMessage(
            'Oops. Something went wrong...',
            this.getTopBanner ? 'error open_top_banner' :'error'
        );
      }

      await this.getListVehicles();
    },
    async getUser() {
      this.user = JSON.parse(localStorage.getItem('user')) || null;
    },
    async getVehicleGroup() {
      let vehicle_groups_result = await this.$http.getAuth(`${this.$http.apiUrl()}/vehicle-groups/${this.user.id}/get-by-id`) || [];

      this.vehicle_groups = vehicle_groups_result?.data?.vehicleGroups?.data || [];
    },
    async checkedCloseCreateGroup(val) {
      if (val) {
        infoMessage(
            `Vehicle group created`,
            this.getTopBanner ? 'success open_top_banner' : 'success'
        );
      } else {
        infoMessage(
            'Oops. Something went wrong...',
            this.getTopBanner ? 'error open_top_banner' :'error'
        );
      }

      await this.getVehicleGroup();
    },
    openCreateVehicleGroup() {
      this.closeManageMenu();
      this.$refs.create_vehicle_group_modal.show = true;
    },
    openCsvUploadFromMenu() {
      this.closeManageMenu();
      this.openCsvUpload();
    },
    openCsvUpload() {
      this.upload_csv = true;
    },
    onCsvUploadDismiss() {
      this.upload_csv = false;
    },
    async onVehiclesCsvImportComplete() {
      this.upload_csv = false;
      await this.getListVehicles();
    },
    async sortItems(name) {
      const j = this.sort_names;
      this.show_buttons = false;
      Object.keys(j).forEach(sort_name => {
        j[sort_name] = false;
      })
      this.ascending = !this.ascending;
      this.sort_names[name] = true
      await this.getListVehicles(name)
    },
    async getListVehicles(sortBy = 'name') {
      try {
        const requestData = {
          skip: this.isInPopup ? (this.popupSkip || 0) : (this.getRowsToShift || 0),
          take: this.isInPopup ? (this.popupTake || this.rows_count) : (this.getItemsToShow || 5),
          sort: sortBy,
          column: this.isInPopup
              ? (this.popupSort || 'registration_number')
              : (this.getSelectedFilterItem || 'registration_number'),
          search: this.isInPopup ? (this.popupSearch || '') : (this.getSearchItemsNames || ''),
          ascending: this.ascending,
        }

        const response = await this.$http
            .getAuth(`${this.$http.apiUrl()}/vehicles?skip=${requestData.skip}&take=${requestData.take}&sort-by=${requestData.sort}&column=${requestData.column}&search=${requestData.search}&sort=${requestData.ascending}`);

        this.vehicles = response?.data?.vehicles?.data || null;
        this.vehicles_count = response?.data?.vehicles?.count || null;
        const list = this.vehicles || [];
        if (this.selected_vehicles_ids.length) {
          this.selectedVehicles = list.filter((vehicle) =>
            this.selected_vehicles_ids.includes(vehicle.id),
          );
          this.assigned_ids = this.selected_vehicles_ids;
          this.checked_vehicle = list.map((vehicle) =>
            this.selected_vehicles_ids.includes(vehicle.id),
          );
          if (this.isInPopup) {
            this.show_buttons = this.checked_vehicle.some(Boolean);
          }
        } else {
          this.checked_vehicle = list.map(() => false);
          this.show_buttons = false;
        }
      } catch (e) {
        console.log(e);
      }
    },
    openDeleteModal() {
      this.delete_id = null;
      this.$refs.delete_modal.show = true;
    },
    closeDeleteModal() {
      this.delete_id = null;
    },
    async deleteSelectedVehicle(index) {
      await this.selectedVehicles.splice(index, 1);
      this.recalcVehiclesDimensions();
    },
    async deleteSelectVehicle() {
      const singleId = this.delete_id;
      try {
        if (singleId) {
          await this.$http.deleteAuth(
            `${this.$http.apiUrl()}/vehicles/${singleId}`,
          );
        } else {
          const ids = [];
          for (let i = 0; i < this.checked_vehicle.length; i++) {
            if (this.checked_vehicle[i]) {
              ids.push(this.vehicles[i].id);
            }
          }
          if (!ids.length) {
            return;
          }
          await this.$http.postAuth(
            `${this.$http.apiUrl()}/vehicles/multiple-deletion`,
            { ids },
          );
        }

        infoMessage(
          singleId ? 'Vehicle deleted!' : 'Vehicles deleted!',
          this.getTopBanner ? 'success open_top_banner' : 'success',
        );

        await this.getListVehicles();
      } catch (e) {
        console.log(e);
        infoMessage(
          'Oops. Something went wrong...',
          this.getTopBanner ? 'error open_top_banner' : 'error',
        );
      } finally {
        this.delete_id = null;
      }
    },
    deleteThisVehicle(index) {
      const vehicle = this.vehicles && this.vehicles[index];
      if (!vehicle) {
        return;
      }
      this.delete_id = vehicle.id;
      this.$refs.delete_modal.show = true;
    },
    async recalcVehiclesDimensions() {
      let vDimensions = structuredClone(this.getVehiclesDimensions);
      if (this.selectedVehicles.length) {
      this.selectedVehicles.forEach((veh, index) => {
        if (index === 0) {
          vDimensions.height.val = veh.height;
          vDimensions.length.val = veh.length;
          vDimensions.width.val = veh.width;
          vDimensions.weight.val = veh.weight;
        } else {
          if (vDimensions.height.val < veh.height) {
            vDimensions.height.val = veh.height;
          }
          if (vDimensions.length.val < veh.length) {
            vDimensions.length.val = veh.length;
          }
          if (vDimensions.width.val < veh.width) {
            vDimensions.width.val = veh.width;
          }
          if (vDimensions.weight.val < veh.weight) {
            vDimensions.weight.val = veh.weight;
          }
        }
      })
      } else {
        vDimensions.height.val = 4;
        vDimensions.length.val = 12;
        vDimensions.width.val = 2.5;
        vDimensions.weight.val = 18;
      }
      this.setSelectedVehicles(this.selectedVehicles)
      await this.$emit('setSelectedVehiclesDimensions', {vDimensions, selectedVehicles: this.selectedVehicles})
      return this.setVehiclesDimensions(vDimensions);
    },
    async reloadItems() {
      this.$router.go();
    }
  },
  async mounted() {
    await this.getUser();
    await this.getVehicleGroup();
    if (!this.isInPopup) {
      await this.getListVehicles();
    }
  },
  computed: {
    ...mapGetters([
      'getItemsToShow',
      'getSelectedFilterItem',
      'getRowsToShift',
      'getSearchItemsNames',
      'getVehiclesDimensions',
      'getTopBanner',
      'getVehiclesDimensions',
      'getSelectedVehicles'
    ]),
    allRowsSelected() {
      const list = this.vehicles || [];
      return (
        list.length > 0 && list.every((_, index) => this.checked_vehicle[index])
      );
    },
    hasAnyRowSelected() {
      const list = this.vehicles || [];
      return list.some((_, index) => this.checked_vehicle[index]);
    },
  },
  components: {
    FiltersDop,
    DeleteModal,
    CreateVehicleGroupModal,
    AssignVehiclesToGroup,
    RemoveVehiclesFromAssignedGroups,
    MenageVehiclesGroup,
    CSVUploadVehicles,
  },
  watch: {
    checked_vehicle() {
      if (this.isInPopup) {
        this.syncSelectedVehiclesFromCheckboxes();
        this.recalcVehiclesDimensions();
        return;
      }
      this.show_buttons = this.hasAnyRowSelected;
    },
    getItemsToShow() {
      if (!this.isInPopup) {
        this.getListVehicles()
      }
    },
    getSelectedFilterItem() {
      if (!this.isInPopup) {
        this.getListVehicles()
      }
    },
    getRowsToShift() {
      if (!this.isInPopup) {
        this.getListVehicles()
      }
    },
    getSearchItemsNames() {
      if (!this.isInPopup) {
        this.getListVehicles()
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.item {
  font-size: 14px;
  padding-right: 25px;
}
.actions {
  &:hover, &:active, &:focus{
    .hidden {
      display: block;
    }
    span {
      &>* {
        cursor: pointer;
      }
      &:first-child {
        &>*{
          margin-left: auto;
        }
      }
    }
  }
}
.title_line {
  padding: 30px 0 22px;
  border-bottom: none;
}
.filters {
  width: 95%;
  margin: auto;
}
.button_text {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 14px;
}
.strong_text {
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  color: #000000 !important;
}
.delete_column {
  width: 49px;
}
.item {
  font-size: 14px;
  span {
    margin-left: 5px;
    color: #969A9F;
  }
}
.span_cut {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.color_black {
  color: black !important;
}
.checked_row {
  background-color: #FFF1CE;
}
.button_group {
  position: relative;

  .full_green_button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    min-width: 133px;

    svg {
      margin-right: 0;
      flex-shrink: 0;
      display: block;
    }

    span {
      padding-top: 0;
      line-height: 1;
    }

    span.whitespace-nowrap {
      align-self: center;
    }
  }

  a.full_green_button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 44px;
    box-sizing: border-box;
  }

  .manage_menu_wrap {
    .manage_group {
      z-index: 99;
      position: absolute;
      top: 48px;
      right: 0;
      border-radius: 8px;
      box-sizing: border-box;
      border: 0.5px solid #D8C3AF;
      box-shadow: 5px 5px rgba(216, 195, 175, 0.5);
      padding: 10px;
      background-color: #FFFFFF;
      white-space: nowrap;
    }

    .manage_menu_item {
      display: block;
      margin: 10px;
      padding: 0;
      background: none;
      border: none;
      font: inherit;
      text-align: left;
      cursor: pointer;
      color: #000000;
    }

    .manage_menu_link {
      text-decoration: none;
    }
  }
}
.vehicles.page {
  position: relative;
  overflow-x: hidden;
}
.blocked {
  position: fixed;
  inset: 0;
  z-index: 98;
}
</style>
